import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { api } from 'controllers/network/apiClient';
import { ConversationFeedbackResponse } from '../../conversations/types';

type FeedbackResponse = ConversationFeedbackResponse;

interface Options {
  refetchInterval?: number;
  onSuccess?: (data: FeedbackResponse) => void;
  onError?: (error: Error) => void;
}

export const FEEDBACK_QUERY_KEY = 'feedback';

export const useFeedback = (
  subscriberId?: number,
  // Scopes the fetch to another shop (admin/sales agents viewing a shop's
  // conversation). Omit for merchants viewing their own shop.
  shopId?: number,
  { refetchInterval, onSuccess, onError }: Options = {},
): UseQueryResult<FeedbackResponse> => {
  return useQuery({
    queryKey: [FEEDBACK_QUERY_KEY, subscriberId, shopId],
    queryFn: (): Promise<FeedbackResponse> =>
      api.get<ConversationFeedbackResponse>(
        `/v2/ai-components/feedback/conversation-feedback/${subscriberId}${
          shopId != null ? `?shop_id=${shopId}` : ''
        }`,
      ),
    enabled: !!subscriberId,
    ...(refetchInterval ? { refetchInterval } : {}),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error: Error) => {
      onError?.(error);
    },
  });
};

export default useFeedback;
